/**
 * AccessibilityManager.js
 * Ekran okuyucular (TalkBack, NVDA vb.) için yardımcı fonksiyonlar.
 */
const AccessibilityManager = {
    liveRegion: null,

    init: function () {
        if (this.liveRegion) return;

        // Create a hidden live region for dynamic announcements
        this.liveRegion = document.createElement('div');
        this.liveRegion.id = 'a11y-live-region';
        Object.assign(this.liveRegion.style, {
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: '0',
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            border: '0'
        });
        this.liveRegion.setAttribute('aria-live', 'polite');
        this.liveRegion.setAttribute('aria-atomic', 'true');
        document.body.appendChild(this.liveRegion);

        console.log('AccessibilityManager Initialized');
    },

    /**
     * Ekran okuyucuya sesli bildirim gönderir.
     * @param {string} message - Okunacak metin
     * @param {string} priority - 'polite' (bekleyip oku) veya 'assertive' (hemen oku)
     */
    announce: function (message, priority = 'polite') {
        if (!this.liveRegion) this.init();

        this.liveRegion.setAttribute('aria-live', priority);
        // İçeriği temizleyip tekrar ekleyerek okumayı tetikle
        this.liveRegion.textContent = '';
        setTimeout(() => {
            this.liveRegion.textContent = message;
        }, 100);
    },

    /**
     * Daktilo efekti için HTML yapısını hazırlar.
     * Görsel metni aria-hidden yapar, ekran okuyucu için gizli bir tam metin ekler.
     * @param {HTMLElement} container - Metnin yazılacağı element
     * @param {string} fullText - Tam soru metni
     * @returns {HTMLElement} - Görsel metnin yazılacağı (boş) element
     */
    setupTypewriter: function (container, fullText) {
        container.innerHTML = ''; // Temizle

        // 1. Ekran okuyucular için gizli tam metin
        const srText = document.createElement('span');
        srText.className = 'sr-only'; // .sr-only CSS sınıfı base.css'de olmalı
        srText.style.cssText = 'position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); border:0;';
        srText.textContent = fullText;
        container.appendChild(srText);

        // 2. Görsel daktilo efekti için alan (Ekran okuyucudan gizli)
        const visualText = document.createElement('span');
        visualText.setAttribute('aria-hidden', 'true');
        container.appendChild(visualText);

        return visualText; // GameUI buraya karakterleri tek tek yazacak
    },

    /**
     * Klavyeyi belirtilen elementin içine hapseder (Modal açıldığında kullanılır).
     * @param {HTMLElement} element - Odaklanılacak modal/kapsayıcı
     */
    trapFocus: function (element) {
        this.previousFocusedElement = document.activeElement; // Odaklanılan son elementi sakla

        const focusableElements = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (!firstElement) return;

        // Modala girildiğinde ilk elemana odaklan
        firstElement.focus();

        const handleKeyDown = (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) { // Shift + Tab (Geri)
                    if (document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                } else { // Tab (İleri)
                    if (document.activeElement === lastElement) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            }
            if (e.key === 'Escape') {
                this.releaseFocus();
                // Opsiyonel: Modalı kapatma işlevini tetiklemek için callback çağrılabilir
            }
        };

        element.addEventListener('keydown', handleKeyDown);
        this.currentTrapListener = handleKeyDown;
        this.currentTrapElement = element;
    },

    /**
     * Odak hapsini kaldırır ve odağı önceki elemente geri verir.
     */
    releaseFocus: function () {
        if (this.currentTrapElement && this.currentTrapListener) {
            this.currentTrapElement.removeEventListener('keydown', this.currentTrapListener);
            this.currentTrapElement = null;
            this.currentTrapListener = null;
        }

        if (this.previousFocusedElement) {
            this.previousFocusedElement.focus();
            this.previousFocusedElement = null;
        }
    }
};

window.AccessibilityManager = AccessibilityManager;
export default AccessibilityManager;
